import { render, staticRenderFns } from "./ConfigImportFile.vue?vue&type=template&id=31841e34&scoped=true&"
import script from "./ConfigImportFile.vue?vue&type=script&lang=js&"
export * from "./ConfigImportFile.vue?vue&type=script&lang=js&"
import style0 from "./ConfigImportFile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConfigImportFile.vue?vue&type=style&index=1&id=31841e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31841e34",
  null
  
)

export default component.exports